import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "bg-white position-relative overflow-auto mw-100",
  style: {"max-height":"670px"}
}
const _hoisted_2 = { class: "table table-bordered mb-6 bg-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-top bg-white" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "position-relative border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Дата создания"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "ФИО"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Тип приказа"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Период"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Примечание"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" })
  ])
], -1)
const _hoisted_4 = { class: "py-2 px-3" }
const _hoisted_5 = { class: "py-2 px-3" }
const _hoisted_6 = { class: "py-2 px-3" }
const _hoisted_7 = { class: "py-2 px-3" }
const _hoisted_8 = { class: "py-2 px-3" }
const _hoisted_9 = {
  class: "py-2 px-3",
  style: {"width":"50px"}
}
const _hoisted_10 = { class: "btn btn-sm d-flex justify-content-center align-items-center" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", {
  class: "py-5 text-center",
  colspan: 4
}, "Приказы отсутствуют", -1)
const _hoisted_13 = [
  _hoisted_12
]

import { reactive, onMounted } from 'vue';
import { userStore } from '@/store/userStore';
import { useModal } from '@/composables/useModal';
import { IEmployeeOrder } from '@/@types/IEmployee';
import formatDate from '@/utils/formatDate';
import api from '@/api';

type stateType = {
    orders: Array<IEmployeeOrder>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderComponent',
  setup(__props, { expose: __expose }) {

const { user } = userStore();
const state: stateType = reactive({
    orders: [],
});

function handleGetOrders() {
    return api.employeeOrder.getMany().then((response) => {
        state.orders = response.data;
    });
}

function handleCreateOrder() {
    useModal('employee_order_modal')
        .open({ type: 'add' })
        .then(handleGetOrders)
        .catch(console.error);
}

function handleEditOrder(employeeOrder: IEmployeeOrder) {
    useModal('employee_order_modal')
        .open({
            type: 'edit',
            employeeOrder,
        })
        .then(handleGetOrders)
        .catch(console.error);
}

function handleDeleteOrder(employeeOrder: IEmployeeOrder) {
    useModal('confirm_modal')
        .open({
            question: 'Подтвердите удаление приказа',
            ok: 'Да',
            cancel: 'Нет',
        })
        .then(() => api.employeeOrder.delete(employeeOrder.id))
        .then(handleGetOrders)
        .catch(console.error);
}

onMounted(handleGetOrders);
__expose({
    onCreateOrder: handleCreateOrder,
});

return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_dropdown_ui = _resolveComponent("dropdown-ui")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (state.orders.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.orders, (employee) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: employee.id
              }, [
                _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(formatDate)(employee.createdAt)), 1),
                _createElementVNode("td", _hoisted_5, _toDisplayString(employee.employee?.name), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(employee.type), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(`${_unref(formatDate)(employee.startsAt)}` +
                                `${employee.endsAt ? ` ${_unref(formatDate)(employee.endsAt)}` : ''}`), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(employee.comment), 1),
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(_component_dropdown_ui, null, {
                    button: _withCtx(() => [
                      _createElementVNode("button", _hoisted_10, [
                        _createVNode(_component_vue_feather, {
                          size: "14px",
                          type: "more-vertical"
                        })
                      ])
                    ]),
                    list: _withCtx(() => [
                      (_unref(user).isAdmin || _unref(user).isKadry || _unref(user).isSuperAdmin)
                        ? (_openBlock(), _createBlock(_component_button_ui, {
                            key: 0,
                            class: "dropdown-item cursor-pointer",
                            onClick: ($event: any) => (handleEditOrder(employee))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Редактировать ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_unref(user).isAdmin || _unref(user).isKadry || _unref(user).isSuperAdmin)
                        ? (_openBlock(), _createBlock(_component_button_ui, {
                            key: 1,
                            class: "dropdown-item cursor-pointer",
                            onClick: ($event: any) => (handleDeleteOrder(employee))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Удалить ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock("tr", _hoisted_11, _hoisted_13))
      ])
    ])
  ]))
}
}

})